import { Component, OnInit } from '@angular/core';
import { PatientServiceService } from '../../services/PatientService.service';
import { ScheduledPatientDataModel } from '../../models/ScheduledPatientData.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EventSettingsModel, View } from '@syncfusion/ej2-schedule';
import { PatientAppointmentService } from '../../services/PatientAppointment.service';
import { Router } from '@angular/router';
import { SchedulerEventModel } from '../../../HospitalPanel/models/SchedulerEventModel';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { PaScheduledInfoModal } from '../../models/PaScheduledInfo.model';

declare var $: any;

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class PaAppointmentComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  caseList: any[];
  SpDataModel: ScheduledPatientDataModel;
  scheduledBy: string = "";
  appointmentList: any[];
  showOverlayAppointment: boolean;
  reschedule: boolean = false;
  scheduleId: string;
  doctorSlots: any[];
  scheduledInfo: PaScheduledInfoModal;
  popUpDiv: boolean;
  cases: any[];
  currentListShow: boolean = false;
  showBookModal: boolean = false;
  selectedAppointmentStartTime;
  selectedAppointmentEndTime;
  selectedAppointmentDate;
  selectedCaseName: string;
  selectedDoctor: string;
  selectedDoctorPhoto: string;
  selectedDoctorMail: string;

  public ScheduleData: object[] = [{
    Id: 1,
    Subject: 'abc',
    fromTime: new Date(2019, 8, 1, 15, 0, 0, 0),
    toTime: new Date(2019, 8, 1, 15, 30, 0, 0),
  }];
  public NewView: View = 'TimelineDay';
  docEvents: SchedulerEventModel[];
  public eventSettingsdata: EventSettingsModel = {
    dataSource: this.getAppointmentData(),
    fields: {
      id: 'Id',
      subject: { name: 'Subject' },
      startTime: { name: 'fromTime' },
      endTime: { name: 'toTime' },
    }
  };
  noteText: any;
  getAppointmentData(): object[] {

    return this.ScheduleData;

  }


  constructor(private _service: PatientAppointmentService, private router: Router, private serv: PatientServiceService, private Saniti: DomSanitizer) { }

  ngOnInit() {

    this.caseList = []
    this.getPatientCases();
    this.NewView = 'Week';
  }

  getDoctorAppointments(doctorId) {

    let dLength = this.ScheduleData.length;
    for (let i = dLength - 1; i >= 0; i--) {
      this.ScheduleData.splice(i, 1);
    }

    if (doctorId != undefined && doctorId != '' && doctorId != null) {
      this._service.getDoctorAppointments(doctorId).subscribe((data: any[]) => {
        this.docEvents = data as SchedulerEventModel[];
        for (let i = 0; i < data.length; i++) {
          this.docEvents[i].fromTime = this.docEvents[i].start;
          this.docEvents[i].toTime = this.docEvents[i].end;
          this.ScheduleData.push(this.docEvents[i]);
        }
      })
    }
  }

  hideBookModal() {
    this.showBookModal = false;
  }

  generateData(): object[] {
    return this.ScheduleData;

  }

  routeToBook() {
    this.router.navigate(['Patient/PAPanel/book']);
  }

  getPatientCases() {
    this.showOverlayAppointment = true;
    this.serv.getPatientCaseList().subscribe((data: any[]) => {
      this.cases = data;
      if (this.cases.length < 1) {
        this.currentListShow = true;
      }
      else {
        this.currentListShow = false;
        for (let i = 0; i < this.cases.length; i++) {
          this.cases[i]["frmTdate"] = new Date(this.cases[i]["frmDate"]);
        }
        this.cases.forEach(i => {
          let fromDate = new Date(i.frmDate);
          i.fromDate = fromDate.getDate() + "-" + (1 + parseInt(fromDate.getMonth().toString())) + "-" + fromDate.getFullYear();
        })
      }
      if (this.cases[0] != undefined && this.cases[0] != null) {
        if (this.cases[0].sId !== undefined && this.cases[0].sId != null && this.cases[0].id !== null && this.cases[0] !== undefined) {
          this.getPatientScheduledInfo({sId:this.cases[0].sId, id:this.cases[0].id});
        }
      }
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
        this.showOverlayAppointment = false;
      }
    }, () => { this.htmlView = true;  this.showOverlayAppointment = false; });

  }

  onEventView(data) {
    data.evt.stopPropagation();
    this.getPatientScheduledInfo1({sId:data.sId, id:data.id});
  }

  onEventViewNote(data) {
    data.evt.stopPropagation();
    this.getPatientNote(data.sId, data.notes, data.id);
  }

  getPatientNote(sId, note, id) {
    $("#scheduleModalNote").modal('show');
    this.resetBorder();
    let index = this.cases.findIndex(a => a.id == id);
    this.addBorder(index);
    var patientNote = note;
    this.noteText = this.Saniti.bypassSecurityTrustHtml(patientNote);
    if (patientNote == undefined || patientNote == null || patientNote == "") {
      this.popUpDiv = true;
    } else {
      this.popUpDiv = false;
    }
  }

  getPatientScheduledInfo(data) {

    this.resetBorder();
    this.scheduleInfo(data.sId);
    let index = this.cases.findIndex(item => item.id == data.id);
    this.addBorder(index);
  }

  getPatientScheduledInfo1(data) {
    this.resetBorder();
    let index = this.cases.findIndex(item => item.id == data.id);
    this.addBorder(index);
    this.scheduleInfo(data.sId);
    $("#scheduleModal").modal('show');

  }

  resetBorder() {
    for (let v of this.cases) {
      v.borderLeft = "";
      v.borderRight = "";
      v.borderBottom = "";
    }
  }

  addBorder(index) {
    this.cases[index].borderLeft = "2px solid #0969c9";
    this.cases[index].borderRight = "2px solid #0969c9";
    this.cases[index].borderBottom = "2px solid #0969c9";
  }

  scheduleInfo(sId) {
    this.scheduledInfo = new PaScheduledInfoModal();
    this.serv.getPatientScheduledInfo(sId).subscribe((data: PaScheduledInfoModal) => {
      this.scheduledInfo = data;
    });
  }












}
